import { STATUSES } from '@/common/constants/reconfiguration.constants';

export const mapInterface = (type, ifs, node) => alert => ({
  ...alert,
  type,
  nodeName: node.name,
  nodeId: node.id,
  interface: ifs.name,
});

export default {
  reconfigurationFinished: state => !!(state.operation && state.taskStatus
    && STATUSES.success.includes(state.taskStatus)),

  reconfigurationRequired: (state, getters) => !getters.reconfigurationFinished
    && !!(state.taskId && state.taskStatus && state.operation && !getters.reconfigurationSilent),

  reconfigurationSilent: state => STATUSES.silent.includes(state.taskStatus),
  task: state => ({
    taskId: state.taskId,
    operation: state.operation,
    taskStatus: state.taskStatus,
    progress: state.progress,
    reason: state.reason,
    singleInterfaceMigration: state.singleInterfaceMigration,
    data: state.data
  }),
  alerts: (state, getters) => ({
    global: getters.task.data?.alerts || [],
    nodes: getters.task.data?.nodes?.reduce((result, node) => result.concat(
      node.alerts.map(alert => ({
        ...alert,
        nodeName: node.name,
        nodeId: node.id,
      }))
    ), []) || [],
    interfaces: getters.task.data?.nodes?.reduce((result, node) => {
      let ifs = [];
      if (node.source_interface) {
        ifs = ifs.concat(node.source_interface.alerts.map(mapInterface('sourceInterface', node.source_interface, node)));
      }
      if (node.target_interface) {
        ifs = ifs.concat(node.target_interface.alerts.map(mapInterface('targetInterface', node.target_interface, node)));
      }
      return result.concat(ifs);
    }, []) || []
  }),
  allAlerts: (state, getters) => getters.alerts.global
    .concat(getters.alerts.nodes)
    .concat(getters.alerts.interfaces),
  getAlertsBySeverity: (state, getters) => severity => getters.allAlerts.filter(alert => alert.severity === severity),
  networkConfiguration: state => id => state.networksConfiguration[id]
};
